import { IsOptional, IsString, IsUUID, ValidateIf } from 'class-validator';

export class CreateHcLotReleaseConfigRequestDto {
    /**
     * Product ID reference
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @ValidateIf((o) => o.productId !== '' && o.productId != null)
    @IsUUID()
    productId?: string;

    /**
     * Who submits (Q&C, MAH, Client, Other)
     * @example 'Q&C'
     */
    @IsOptional()
    @IsString()
    submittedBy?: string;

    /**
     * Email for HC submission
     * @example 'cerb.lot_release@hc-sc.gc.ca'
     */
    @IsOptional()
    @IsString()
    submissionEmailTo?: string;

    @IsOptional()
    @IsString()
    group?: string;

    /**
     * Notes on the process
     * @example 'Additional HC submission notes'
     */
    @IsOptional()
    @IsString()
    notes?: string;
}
